import { connect } from 'react-redux';
import {
  loadDataCredentials,
  loadVendorAuths,
  loadUserQuarantine,
  saveUserQuarantine,
  addCredentialAndProbe,
  updateCredentialAndProbe,
  probeGetConnectionTree,
  probeToggleTreeNode,
  clearNewCredentialForQuarantine,
  setFormStageIndex,
  setContextualSupport,
  unsetContextualSupport,
} from '../../actions';
import { getCurrentUser, getCredentialsByType } from '../../reducers/selectors';
import EditQuarantineForm from './EditQuarantineForm';
import { has, isEmpty } from 'lodash';
import { getConnectionOrVendorType } from '../../lib/ResourceUtils';

const mapStateToProps = (state) => {
  const {
    paging,
    entities: { quarantineConfig, credentials, vendors },
    credentials: { byId, probeStatus },
    request,
    users: { quarantine },
  } = state;
  const user = getCurrentUser(state);
  const isLoadingSaveCredential =
    request.ADD_CREDENTIAL_REQUEST ||
    request.UPDATE_CREDENTIAL_REQUEST ||
    request.PROBE_CREDENTIAL_REQUEST ||
    request.GET_CREDENTIAL_REQUEST ||
    false;
  const isLoadingCredentials = !!request.GET_ALL_CREDENTIALS_REQUEST;
  let quarantineObj;
  let credential = {};

  if (quarantineConfig && quarantine.id) {
    quarantineObj = quarantineConfig[quarantine.id];
    credential = credentials[quarantineObj.data_credentials];
    if (!credential) {
      quarantineObj = null;
      credential = {};
    }
  }

  let newCredential;

  if (has(credentials, quarantine.newCredentialId)) {
    newCredential = credentials[quarantine.newCredentialId];
  }

  const currentCredentialType = !isEmpty(credential)
    ? getConnectionOrVendorType(credential, vendors, 'credentials_type', 'vendor_id')
    : null;

  return {
    userId: user && user.id,
    credentialsById: byId,
    paging,
    credentialsByType: getCredentialsByType(state),
    vendors,
    isLoadingSaveCredential,
    isLoadingCredentials,
    probeStatus,
    quarantine,
    quarantineObj,
    credential,
    newCredential,
    currentCredentialType,
    isNew: !(quarantineObj && quarantineObj.id),
  };
};

const EditQuarantineFormContainer = connect(mapStateToProps, {
  loadDataCredentials,
  loadVendorAuths,
  loadUserQuarantine,
  saveUserQuarantine,
  addCredentialAndProbe,
  updateCredentialAndProbe,
  probeGetConnectionTree,
  probeToggleTreeNode,
  clearNewCredentialForQuarantine,
  setFormStageIndex,
  setContextualSupport,
  unsetContextualSupport,
})(EditQuarantineForm);

export default EditQuarantineFormContainer;
